<template>
    <div class="text-left" id="calendar-side">
        <div class="row">
            <div class="col text-left mt-3">
                <button class="close round" @click="$emit('close', date)">
                    <font-awesome-icon icon="times"></font-awesome-icon>
                </button>
            </div>
        </div>
        <div class="p-3">
            <h5 class="m-0">Geselecteerde datum:</h5>
            <span>{{date.date.toLocaleDateString()}}</span>
            <hr>
            
            <h5 >Beschikbaarheid</h5>
            <div class="form-check">
                <input class="form-check-input" type="radio" name="availability" id="availability1" :value="false" v-model="date.blocked" @change="save('Blocked', date.blocked)" >
                <label class="form-check-label" for="availability1">
                    Beschikbaar
                </label>
                </div>
                <div class="form-check">
                <input class="form-check-input" type="radio" name="availability" id="availability2" :value="true" v-model="date.blocked" @change="save('Blocked', date.blocked)" >
                <label class="form-check-label" for="availability2">
                    Geblokkeerd
                </label>
            </div>
            <hr>

            <h5 >Tarieven</h5>
            <rates :date="date" @save="save"></rates>
        </div>
    </div>
</template>

<script>
import Rates from '@/components/Rates';
export default {
    name: 'calendar-side',
    props: ['date'],
    components: {
        Rates
    },
    data() {
        return {
        }
    },
    methods: {
        save(property, value) {
            this.$http.post('api/Rates/' + property + '?date=' + this.date.date.toDateString(), JSON.stringify(value)).then(() => {
                this.$emit('update', { property: property, value: value})
            })
        }
    },
    watch: {
    }
}
</script>

<style scoped>

button.round {
    float: left;
}


</style>